<template>
    <div
        v-if="text"
        class="bsdc-notice"
        :class="`bsdc-notice--${type}`"
    >
        <p class="bsdc-notice-text">{{ text }}</p>
    </div>
</template>

<script setup>
    const { text, type } = defineProps({
        text: String,
        type: {
            type: String,
            default: 'error',
        },
    });
</script>

<style>
    @reference "../../css/app.css";

    .bsdc-notice {
        @apply bsdc:bg-2-1 bsdc:p-6 bsdc:border-l-4 bsdc:border-solid bsdc:rounded-md;
    }

    .bsdc-notice-text {
        @apply bsdc:text-base;
    }

    .bsdc-notice--error {
        @apply bsdc:border-red-600;

        .bsdc-notice-text {
            @apply bsdc:text-red-600;
        }
    }

    .bsdc-notice--warning {
        @apply bsdc:border-yellow-600;

        .bsdc-notice-text {
            @apply bsdc:text-yellow-600;
        }
    }
</style>
